const Project = {

    // FIELDS
    "tagline": "Start your Polyhouse Journey — Choose Nature & Structure Type to proceed",
    "dpr": "Required Details for DPR (Shade Net House & Poly House) All type vegetable & floriculture",
    "nature": "Project Nature",
    "type": "Structure Type",
    "application_form": "Application Form",
    "customer": "Customer",
    "project_name": "Project Name",
    "name": "Name",
    "so/wo": "So/Wo",
    "dob": "Date of Birth",
    "mobile": "Mobile",
    "email": 'Email',
    "address": 'Address',
    "district": 'District',
    "tehsil": 'Tehsil',
    "post": 'Post',
    "pincode": 'Pincode',
    "total_land": 'Total Land',
    "survey_no": 'Survey Number',
    "valuation_cost": 'Total Land Valuation Cost',
    "cast": 'Caste Category',
    "state": 'State',
    "pan": 'Pan Number',
    "aadhar": 'Aadhar Number',

    "project_location": "Project Location",
    "project_area": "Project Area (Sq. Mtr.)",
    "lat": "Lattitude",
    "lng": "Longitude",
    "crop_name": "Crop Name",
    "signature": "Signature",

    "complete": "Complete",
    "change_status": "Change Status",
    "stage": "Stage",
    "next": "Mark is Completed",
    "skip": "Skip",
    "all_stages_completed": "All stages completed",
    "confirm_skip_title": "Are you sure you want to skip this stage?",

    "search": "Search",

    // PAGE HEADER
    "project": "Project",

    // TOAST
    "status_update": "Status Updated Successfully",
    "stage_update": "Stage Updated Successfully",
    "confirm_title": "Are you sure you want to complete this project?",
    "revert_text": "You won't be able to revert this!",
    "revert_stage": "Revert Stage!",
    "confirm_stage_title": "Are you sure you want to add project stage?",

    // ERROR
    "error_nature": "Select Project Nature",
    "error_type": "Select Structure Type",
    "error_project_name": "Enter Project Name",
    "error_customer": "Select Customer",
    "error_name": "Enter Name",
    "error_so/wo": "Enter So/Wo",
    "error_dob": "Choose Date of Birth",
    "error_mobile": "Enter Mobile Number",
    "error_invalid_phone": "Invalid Mobile Number",
    "error_email": 'Enter Email',
    "error_address": 'Enter Address',
    "error_district": 'Select District',
    "error_tehsil": 'Select Tehsil',
    "error_post": 'Enter Post',
    "error_pincode": 'Enter Pincode',
    "error_invalid_pincode": 'Invalid Pincode',
    "error_total_land": 'Enter Total Land',
    "error_survey_no": 'Enter Survey Number',
    "error_valuation_cost": 'Enter Total Land Valuation Cost',
    "error_cast": 'Select Caste Category',
    "error_state": 'Select State',
    "error_pan": 'Enter Pan Number',
    "error_invalid_pan": 'Invalid Pan Number',
    "error_aadhar": 'Enter Aadhar Number',
    "error_invalid_aadhar": 'Invalid Aadhar Number',
    "error_project_area": "Enter Project Area",
    "error_lat": "Enter Lattitude",
    "error_lng": "Enter Longitude",
    "error_invalid_lat": "Enter a valid latitude between -90 and 90",
    "error_invalid_lng": "Enter a valid longitude between -180 and 180",
    "error_crop_name": "Enter Crop Name",
    "error_signature": "Choose Signature",

    // TABLE HEADER
    "table_project": 'PROJECT',
    "table_nature": 'NATURE',
    "table_structure": "STRUCTURE",
    "table_name": "NAME",
    "table_mobile": "MOBILE",
    "table_tehsil": "TEHSIL",
    "table_status": "STATUS",

}

export default Project;